module.exports = __webpack_public_path__ + "resources/img/logo_toastbill.e80c963559d1b65ce00b674f09361bf0.png";